import React from 'react';
import { Alert, Stack, Chip, Typography } from '@mui/material';
import { analyzeSmsEncoding } from '../utils/smsEncoding';

const SmsEncodingNotice = ({ message }) => {
  if (!message) return null;

  const analysis = analyzeSmsEncoding(message);
  const severity = analysis.hasEmoji ? 'error' : analysis.encoding === 'UCS-2' ? 'warning' : 'info';

  return (
    <Alert severity={severity} sx={{ mb: 2 }}>
      <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
        <Chip size="small" label={analysis.encoding} />
        <Chip size="small" label={`${analysis.segments} SMS segment${analysis.segments === 1 ? '' : 's'}`} />
        <Typography variant="body2">
          {analysis.hasEmoji
            ? 'Remove emoji before sending; they increase billable SMS segments.'
            : analysis.encoding === 'UCS-2'
              ? 'This message contains Unicode characters and may cost more to send.'
              : 'Standard SMS encoding is in use.'}
        </Typography>
      </Stack>
    </Alert>
  );
};

export default SmsEncodingNotice;
